module.exports = __webpack_public_path__ + "img/ico_detail_r.2420a373.svg";